export default __webpack_public_path__ + "static/media/CuciStep3.6fdab2fc.png";